'use client'

import { useLoadInitialServicesAndModals } from './hooks'
import { ModalsServices } from './ModalsServices'
import type { IAuthUser, IProfileUser } from '../../../interfaces/src'

interface ModalsServicesProviderProps {
  cookieProfile: IProfileUser
  cookieAuthUser: IAuthUser
}

export const ModalsServicesProvider = ({
  cookieProfile,
  cookieAuthUser
}: ModalsServicesProviderProps) => {
  useLoadInitialServicesAndModals({
    authUser: cookieAuthUser,
    profile: cookieProfile
  })

  return <ModalsServices />
}

export default ModalsServicesProvider
